import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles({
  barContainer: {
    width: '100vw',
    height: '69px',
    position: 'fixed',
    bottom: 0,
    left: 0,
    backgroundColor: 'white',
    paddingRight: '32px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    borderTop: '1px solid #eaeaea',
    zIndex: 1000
  },
  buttonContainer: {
    display: 'flex',
    gap: '1rem',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between'
  }
});

const BottomNavBar = ({
  rightButtons,
  leftButtons,
  margin_top = '0px'
}: {
  rightButtons: any;
  leftButtons?: any;
  margin_top?: string;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.barContainer}>
      <div>
        {leftButtons &&
          leftButtons.map((button: any, index: number) => (
            <div key={index}>{button}</div>
          ))}
      </div>
      <div
        className={classes.buttonContainer}
        style={{ marginTop: margin_top }}
      >
        {rightButtons &&
          rightButtons.map((button: any, index: number) => (
            <div key={index}>{button}</div>
          ))}
      </div>
    </div>
  );
};

export default BottomNavBar;
